import { Box, Typography } from "@mui/material";
import { FC, useCallback } from "react";
import { ProductOption } from "../../../../../components/filters/ProductFilter/types";
import { ProductInput } from "../../../../../components/input/ProductInput/ProductInput";
import { useWorkspaceStore } from "../../../../../store/workspace/WorkspaceStore";
import { ICPAnalysisMethod } from "../../../types";
import { ICPInputActions } from "../ICPInputActions";

interface ICPProductBasedAnalysisInputProps {
  onViewAnalysis: () => void;
}

/**
 * ICP Product-based Analysis Input component
 * Allows users to select products for ICP analysis
 */
export const ICPProductBasedAnalysisInput: FC<
  ICPProductBasedAnalysisInputProps
> = ({ onViewAnalysis }) => {
  const icpSelectedProducts = useWorkspaceStore(
    (state) => state.icpSelectedProducts
  );
  const setICPSelectedProducts = useWorkspaceStore(
    (state) => state.setICPSelectedProducts
  );
  const saveICPToDraft = useWorkspaceStore((state) => state.saveICPToDraft);

  const handleProductsSelect = useCallback(
    (products: ProductOption[]) => {
      const productIds = products.map((product) => Number(product.value));
      setICPSelectedProducts(productIds);
      saveICPToDraft();
    },
    [setICPSelectedProducts, saveICPToDraft]
  );

  return (
    <Box>
      <Box paddingTop={2.5}>
        <ProductInput
          onProductsSelect={handleProductsSelect}
          selectedProductIds={icpSelectedProducts}
        />
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", marginTop: 1 }}
      >
        e.g. Oracle MySQL, MS Azure, etc.
      </Typography>
      <ICPInputActions
        analysisMethod={ICPAnalysisMethod.PRODUCT_BASED}
        onViewAnalysis={onViewAnalysis}
      />
    </Box>
  );
};
